import React from "react";
import { TwoColumnSliderSection } from "../components/TwoColumnSlider";
import { VideoSection } from "../components/common/VideoSection";
import { SideTitleSliderSection } from "../components/SideTitleSliderSection";
import SectionDivider from "../components/common/SectionDivider";
import { HeroImageSection } from "../components/common/HeroImageSection";

const LifestylePage: React.FC = () => {

    const gymSlides = [
        {
            title: 'EXPANSIVE CARDIO SECTION',
            image: '/images/gym_4.webp'
        },
        {
            title: 'CUTTING EDGE TRAINING',
            image: '/images/gym_2.webp'
        },
        {
            title: 'STATE OF THE ART EQUIPMENT',
            image: '/images/gym_3.webp'
        },
    ]

    const activitySlides = [
        {
            title: 'AQUA YOGA',
            image: '/images/activity_1.webp'
        },
        {
            title: 'SPINNING SESSION',
            image: '/images/activity_2.webp'
        },
        {
            title: 'CARDIO SESSION',
            image: '/images/activity_3.webp'
        },
    ]

    const spaSlides = [
        {
            title: 'RELAXING ATMOSPHERE',
            image: '/images/spa_3.webp'
        },
        {
            title: 'CALMING EXPERIENCES',
            image: '/images/spa_4.webp'
        },
        {
            title: 'SERENE MASSAGE',
            image: '/images/spa_5.webp'
        },
        {
            title: 'THERAPUTIC EXPERIENCES',
            image: '/images/spa_6.webp'
        },
    ]

    const meditationSlides = [
        { image: '/images/meditation_1.jpg' },
        { image: '/images/meditation_2.jpg' },
        { image: '/images/meditation_3.jpg' }
    ]

    const openMicSlides = [
        {
            image: '/images/open_mic_1.webp'
        },
        {
            image: '/images/open_mic_2.webp'
        }
    ]

    return (
        <div className="bg-dark-mode text-ivory">
            <HeroImageSection
                text="LIFESTYLE & WELLNESS"
                image="/images/meditation.jpg"
                nextSectionId="gym-section"
            />
            <SideTitleSliderSection
                id="gym-section"
                title="GYM"
                description="TRAIN-TRANSFORM-THRIVE"
                slides={gymSlides}
            />
            <SectionDivider />
            <TwoColumnSliderSection
                id="activity-classes-section"
                title="ACTIVITY CLASSES"
                slides={activitySlides}
            />
            <VideoSection
                id="cards-room-video-section"
                title="CARDS ROOM"
                videoSrc="/videos/card_room.mp4"
                nextSectionId="spa-and-therapy-section"
                showControls={false}
            />
            <SideTitleSliderSection
                id="spa-and-therapy-section"
                title="SPA & THERAPY"
                description="A WORLD OF RELAXATION"
                slides={spaSlides}
                isLeftAligned={false}
            />
            <SideTitleSliderSection
                id="meditation-section"
                title="DEDICATED MEDITATION AREA"
                description="FIND YOUR INNER CALM"
                slides={meditationSlides}
            />
            <SideTitleSliderSection
                id="open-mic-section"
                title="OPEN MIC"
                description="VOICES UNPLUGGED"
                slides={openMicSlides}
            />
        </div>
    );
};

export default LifestylePage;